import React, { Component } from "react";

import HSGLogo from "./../Assets/hsg-logo.png";

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        return (
            <div ref="auth-header" className="hsg-auth-header-root">
                <div className="">
                    <img className="hsg-auth-header-logo" alt="Health Set Go" src={HSGLogo} />
                </div>
            </div>
        );
    }
}

export default Header;
